/** Bottom inset so shell floating Ask AI never covers the last List content. */
export const MOBILE_FLOATING_ASK_AI_SCROLL_PADDING = 120

/**
 * Extra inset when the floating response preview bubble is open.
 * Bubble content max-height is 350px; include header/gap so last rows stay scrollable.
 */
export const MOBILE_FLOATING_ASK_AI_PREVIEW_SCROLL_PADDING = 420

/** CSS custom property set on the mobile shell body for List scroll insets. */
export const MOBILE_FLOATING_ASK_AI_SCROLL_PADDING_VAR = '--mobile-floating-ask-ai-scroll-padding'
